export default "__VITE_ASSET__2e57986b__"